<div [formGroup]="parentForm">
  <div class="da-card" formGroupName="parentsDetails">
    <h3 class="card-title">Parents' Details</h3>

    <div class="sub-section-label">FATHER'S DETAILS</div>

    <div class="form-grid single-col">
      <div class="field-group">
        <label>Full Name </label>
        <input pInputText formControlName="fatherName" placeholder="Father's full name" maxlength="50"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'fatherName')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'fatherName')" />
        <app-field-error [control]="parentsDetailsForm.get('fatherName')" type="personName" fieldName="Name"></app-field-error>
      </div>
    </div>

    <div class="form-grid two-col-row">
      <div class="field-group">
        <label>Mobile Number </label>
        <!-- ✅ maxlength="10" prevents typing beyond 10 digits in browser -->
        <input pInputText formControlName="fatherMobile" placeholder="+91 00000 00000" maxlength="10"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'fatherMobile')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'fatherMobile')" />
        <app-field-error [control]="parentsDetailsForm.get('fatherMobile')" type="mobile10" fieldName="Mobile Number"></app-field-error>
      </div>
      <div class="field-group">
        <label>Email </label>
        <input pInputText formControlName="fatherEmail" placeholder="father@email.com"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'fatherEmail')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'fatherEmail')" />
        <app-field-error [control]="parentsDetailsForm.get('fatherEmail')" type="email" fieldName="Email"></app-field-error>
      </div>
    </div>

    <div class="divider-line"></div>

    <div class="sub-section-label">MOTHER'S DETAILS</div>

    <div class="form-grid single-col">
      <div class="field-group">
        <label>Full Name</label>
        <input pInputText formControlName="motherName" placeholder="Mother's full name" maxlength="50"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'motherName')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'motherName')" />
        <app-field-error [control]="parentsDetailsForm.get('motherName')" type="personNameOptional" fieldName="Name"></app-field-error>
      </div>
    </div>

    <div class="form-grid two-col-row">
      <div class="field-group">
        <label>Mobile Number</label>
        <input pInputText formControlName="motherMobile" placeholder="+91 00000 00000" maxlength="10"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'motherMobile')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'motherMobile')" />
        <app-field-error [control]="parentsDetailsForm.get('motherMobile')" type="mobile10Optional" fieldName="Mobile Number"></app-field-error>
      </div>
      <div class="field-group">
        <label>Email</label>
        <input pInputText formControlName="motherEmail" placeholder="mother@email.com"
          [class.ng-invalid]="isFieldInvalid(parentsDetailsForm, 'motherEmail')"
          [class.ng-dirty]="isFieldInvalid(parentsDetailsForm, 'motherEmail')" />
        <app-field-error [control]="parentsDetailsForm.get('motherEmail')" type="emailOptional" fieldName="Email"></app-field-error>
      </div>
    </div>

    <div class="flex justify-content-end mt-3" style="display: flex; justify-content: flex-end; margin-top: 1.5rem;">
      <button pButton type="button" [label]="fatherRecordId || motherRecordId ? 'Update' : 'Save'" icon="pi pi-check"
        class="p-button-sm p-button-primary"
        [loading]="isSaving"
        [disabled]="isSaving"
        style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
        (click)="saveParentInfo()">
      </button>
    </div>
    <div class="unsaved-warning" *ngIf="parentsDetailsForm.dirty">
      You have unsaved changes. Please click {{ fatherRecordId || motherRecordId ? 'Update' : 'Save' }} to continue.
    </div>
  </div>
  <p-toast></p-toast>
</div>